import { useContext } from "react";
import { ShellContext } from "../context";

/**
 * Returns the shell root path.
 */
export function useShellRootPath(): string {
  const { rootPath } = useContext(ShellContext);
  return rootPath;
}
